import { Table, Button, Row, Col, Input, Card,Tag} from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import RaiseDuplicateModal from '../Modals/RaiseDuplicateModal';
import moment from 'moment';
import { connect } from 'react-redux';
import { submitDuplicate } from '../../store/action/business/LeadAction';
import { SearchOutlined } from "@ant-design/icons";

const LeadsTable = (props) => {

    const [recordId, setRecordId] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    

    const columns = [
        {
            title: 'Registered Date',
            dataIndex: 'createdAt',
            key: 'leadId',
            render: (regdate) => {
                const regDate =  moment(regdate).format('DD-MM-YYYY')
                const isNew = moment().diff(moment(regDate), 'hours') < 24;

                return(
                    <div style={{display:'flex'}}>
                    <p style={{ margin: 0 }}>{regDate}</p>
                    {isNew && (
                    <Tag color="green" style={{ marginLeft: '5px' }}>
                    New
                    </Tag>
                    )}
                   
                  </div>
                )
            }
        },
        {...(!props.mini && {
            title: 'Lead Id',
            dataIndex: 'leadId',
            key: 'leadId',
        })},
        {
            title: 'Name',
            dataIndex: ['leadData', 'name'],
            key: 'leadId',
        },
        {
            title: 'Phone',
            dataIndex: ['leadData', 'phone'],
            key: 'leadId',
        },
        {
            title: 'Email',
            dataIndex: ['leadData', 'email'],
            key: 'leadId',
        },
    ];

    const RaiseDuplicate = (record) => {
        setRecordId(record.leadId);
        setModalVisible(true);
    }
    const submitDuplicate = (refLeadId, issueDetail) => {
        setModalVisible(false);
        const data = {
            leadId: recordId,
            refLeadId: refLeadId,
            issueDetail: issueDetail
        }
        props.submitDuplicate_(data);
    }

    const filteredLeads = (props.leads || []).filter((lead) => {
        return (
          searchTerm.trim() === "" || // If search is empty, return all data
          lead.leadData?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          lead.leadData?.propertyType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          lead.leadData?.propertySize?.toString().includes(searchTerm) ||
          lead.leadData?.timeToCall?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          lead.leadData?.movingFrom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          lead.leadData?.movingTo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          lead.leadData?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          lead.leadData?.phone?.toString().includes(searchTerm) 
        );
      });
      

    return (
        <div>
                <Card extra={
                        <Input placeholder="Search anything..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)} 
                            prefix={<SearchOutlined style={{ color: "#888" }} />}
                            style={{ borderRadius: "5px", padding: "8px 12px" }} />}
                    style={{ height: '100%' }}>
                    <Table
                        columns={columns}
                        dataSource={filteredLeads}
                        pagination={!props.mini}
                        rowKey={"leadId"}
                        // expandable={props.expand ? {
                        //     expandedRowRender: (record) => (
                        //         <>
                        //             <Row>
                        //                 <Col span={4}> Available time to call:</Col>
                        //                 <Col span={6}>{record.leadData.timeToCall}</Col>
                        //                 <Col span={2}>Email:</Col>
                        //                 <Col span={12}>{record.leadData.email}</Col>
                        //             </Row>
                        //             <br></br>
                        //             <Row>
                        //                 <Col span={4}> Property Type:</Col>
                        //                 <Col span={6}>{record.leadData.propertyType}</Col>
                        //                 <Col span={3}> Property Size:</Col>
                        //                 <Col span={6}>{record.leadData.propertySize}</Col>
                        //             </Row>
                        //             {/* <p style={{ float: "right" }}>
                        //                 <Button type="link" danger onClick={() => RaiseDuplicate(record)
                        //                 }>Raise Duplicate</Button>
                        //             </p> */}
                        //         </>

                        //     ),
                        // } : false}
                        footer={() => props.mini && props.leads.length > 0 ? (
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: 'center' }}>
                                    <Link to="/my-leads">View More</Link>
                                </td>
                            </tr>
                        ) : null}
                    />
                </Card>



            <RaiseDuplicateModal refId={recordId} visible={modalVisible} onOk={submitDuplicate} onCancel={() => setModalVisible(false)} key={recordId} />
        </div>
    )
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
    submitDuplicate_: (data) => {
        dispatch(submitDuplicate(data));
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeadsTable);




// import { Table, Button, Row, Col, Input, Card,Tag} from 'antd';
// import { useState } from 'react';
// import { Link } from 'react-router-dom';
// import RaiseDuplicateModal from '../Modals/RaiseDuplicateModal';
// import moment from 'moment';
// import { connect } from 'react-redux';
// import { submitDuplicate } from '../../store/action/business/LeadAction';
// import { SearchOutlined } from "@ant-design/icons";

// const LeadsTable = (props) => {

//     const [recordId, setRecordId] = useState(null);
//     const [modalVisible, setModalVisible] = useState(false);
//     const [searchTerm, setSearchTerm] = useState("");
    

//     const columns = [
//         {
//             title: 'Registered Date',
//             dataIndex: 'createdAt',
//             key: 'leadId',
//             render: (regdate) => {
//                 const regDate =  moment(regdate).format('DD-MM-YYYY')
//                 const isNew = moment().diff(moment(regDate), 'hours') < 24;

//                 return(
//                     <div style={{display:'flex'}}>
//                     <p style={{ margin: 0 }}>{regDate}</p>
//                     {isNew && (
//                     <Tag color="green" style={{ marginLeft: '5px' }}>
//                     New
//                     </Tag>
//                     )}
                   
//                   </div>
//                 )
//             }
//         },
//         {...(!props.mini && {
//             title: 'Lead Id',
//             dataIndex: 'leadId',
//             key: 'leadId',
//         })},
//         {
//             title: 'Name',
//             dataIndex: ['leadData', 'name'],
//             key: 'leadId',
//         },
//         {
//             title: 'Phone',
//             dataIndex: ['leadData', 'phone'],
//             key: 'leadId',
//         },
//         {
//             title: 'Email',
//             dataIndex: ['leadData', 'email'],
//             key: 'leadId',
//         },
//     ];

//     const RaiseDuplicate = (record) => {
//         setRecordId(record.leadId);
//         setModalVisible(true);
//     }
//     const submitDuplicate = (refLeadId, issueDetail) => {
//         setModalVisible(false);
//         const data = {
//             leadId: recordId,
//             refLeadId: refLeadId,
//             issueDetail: issueDetail
//         }
//         props.submitDuplicate_(data);
//     }

//     const filteredLeads = (props.leads || []).filter((lead) => {
//         return (
//           searchTerm.trim() === "" || // If search is empty, return all data
//           lead.leadData?.email?.toLowerCase().includes(searchTerm.toLowerCase()) || 
//           lead.leadData?.propertyType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           lead.leadData?.propertySize?.toString().includes(searchTerm) || 
//           lead.leadData?.timeToCall?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           lead.leadData?.movingFrom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           lead?.leadData?.movingTo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           lead?.leadData?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           lead?.leadData?.phone?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//       });
    

//     return (
//         <div>
//                 <Card extra={
//                         <Input placeholder="Search anything..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)} 
//                             prefix={<SearchOutlined style={{ color: "#888" }} />}
//                             style={{ borderRadius: "5px", padding: "8px 12px" }} />}
//                     style={{ height: '100%' }}>
//                     <Table
//                         columns={columns}
//                         dataSource={filteredLeads}
//                         pagination={!props.mini}
//                         rowKey={"leadId"}
//                         // expandable={props.expand ? {
//                         //     expandedRowRender: (record) => (
//                         //         <>
//                         //             <Row>
//                         //                 <Col span={4}> Available time to call:</Col>
//                         //                 <Col span={6}>{record.leadData.timeToCall}</Col>
//                         //                 <Col span={2}>Email:</Col>
//                         //                 <Col span={12}>{record.leadData.email}</Col>
//                         //             </Row>
//                         //             <br></br>
//                         //             <Row>
//                         //                 <Col span={4}> Property Type:</Col>
//                         //                 <Col span={6}>{record.leadData.propertyType}</Col>
//                         //                 <Col span={3}> Property Size:</Col>
//                         //                 <Col span={6}>{record.leadData.propertySize}</Col>
//                         //             </Row>
//                         //             {/* <p style={{ float: "right" }}>
//                         //                 <Button type="link" danger onClick={() => RaiseDuplicate(record)
//                         //                 }>Raise Duplicate</Button>
//                         //             </p> */}
//                         //         </>

//                         //     ),
//                         // } : false}
//                         footer={() => props.mini && props.leads.length > 0 ? (
//                             <tr>
//                                 <td colSpan={columns.length} style={{ textAlign: 'center' }}>
//                                     <Link to="/my-leads">View More</Link>
//                                 </td>
//                             </tr>
//                         ) : null}
//                     />
//                 </Card>



//             <RaiseDuplicateModal refId={recordId} visible={modalVisible} onOk={submitDuplicate} onCancel={() => setModalVisible(false)} key={recordId} />
//         </div>
//     )
// }

// const mapStateToProps = state => ({})

// const mapDispatchToProps = dispatch => ({
//     submitDuplicate_: (data) => {
//         dispatch(submitDuplicate(data));
//     },
// })

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(LeadsTable);

